import React, { ReactElement } from 'react';
import './DocumentCard.less';
import { Modal, Button } from 'antd';
import FileUploadComp from './FileUpload';
import { canActivate } from '../../../utils/utility';
import { authFeatureConstants } from '../../../shared/constants/commonConstants';

interface IProps {
  isUploadModal: any;
  closeModal: any;
  saveUploadedDetails: any;
  uploadedDocDetails: any;
  deleteFileId: any;
  selectedFolder: any;
  getUploadedFileDetails: any;
  removeUploadedFiles: any;
}

const UploadModal = (props: IProps): ReactElement => {

  const { isUploadModal, closeModal, saveUploadedDetails, uploadedDocDetails, deleteFileId,
    selectedFolder, getUploadedFileDetails, removeUploadedFiles } = props;

  return (
    <Modal wrapClassName="doc-upload-modal"
      width={700}
      title={<span className="text-capitalize">
      {selectedFolder && selectedFolder.length > 0 ? selectedFolder[0].displayTypeName : ''}
      </span>}
      visible={isUploadModal}
      onCancel={closeModal}
      footer={[
        <Button key="close" type="default" onClick={closeModal}>
          Cancel
          </Button>,
        <Button key="submit" type="primary" onClick={(): any => saveUploadedDetails()}
          disabled={(
            uploadedDocDetails &&
            uploadedDocDetails.length &&
            uploadedDocDetails.filter((v: any): any => (v.startDate && v.endDate))?.length)
            || (deleteFileId && deleteFileId.length > 0) ? false : true}>
          Save
          </Button>,
      ]}
      maskClosable={false}
    >
      {
        isUploadModal && <FileUploadComp folderData={selectedFolder}
          uploadedFileDetails={getUploadedFileDetails}
          removeUploadedFiles={removeUploadedFiles}
          isUploadDisabled={!canActivate(authFeatureConstants.EDIT_DOCUMENTS)}
        />
      }
    </Modal>
  );
};

export default UploadModal;
